<template>
  <div class="wrap">
    <dl class="tip primary">
      <dt class="text-bold"><i class="el-icon-bell" />操作提示</dt>
      <dd class="text-info">需要先选择客户单位后，方可添加商品清单</dd>
    </dl>
    <div class="form">
      <el-form ref="ff" v-loading="loading" :model="order" label-position="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客户单位" prop="CustomerId" required>
              <customerPicker
                v-model="order.CustomerName"
                clearable
                style="width: 100%"
                @change="pickCustomer"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系人" prop="Linkman">
              <el-input v-model="order.Linkman" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="电话" prop="Linktel">
              <el-input v-model="order.Linktel" />
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="地址" prop="Linkman">
              <el-input v-model="order.Address" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单类别" prop="Type" required>
              <metaPicker type="branch" :value.sync="order.Type" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-card
          shadow="never"
          body-style="padding:0"
          style="margin-bottom: 20px"
        >
          <div slot="header" class="toolbar">
            <h3>商品清单</h3>
            <el-link type="primary" icon="el-icon-plus" @click="pickGoods"
              >添加商品</el-link
            >
          </div>
          <el-table :data="order.Items">
            <el-table-column width="60" align="center">
              <template slot-scope="scope">
                <el-link
                  type="danger"
                  :underline="false"
                  class="el-icon-remove"
                  style="font-size: 20px"
                  @click="onRemove(scope)"
                />
              </template>
            </el-table-column>
            <el-table-column prop="Code" label="库存编码" width="100" />
            <el-table-column prop="Name" label="商品名称" />
            <el-table-column width="100">
              <template slot-scope="{ row }">
                <label class="text-price text-danger"
                  >{{ row.Price }}/{{ row.Unit }}</label
                >
              </template>
            </el-table-column>
            <el-table-column label="订购数量" width="180">
              <template slot-scope="{ row }">
                <el-input-number v-model="row.Amount" :min="1" size="small" />
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-form-item prop="Remark" label="订单备注">
          <el-input type="textarea" :rows="5" v-model="order.Remark" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit()">提交订单</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import goodsPicker from "@/views/mall/goods/_picker.vue";
export default {
  components: {
    metaPicker: () => import("@/views/system/meta/item/_picker.vue"),
    customerPicker: () => import("@/views/company/customer/_picker.vue"),
  },
  data() {
    return {
      loading: false,
      order: {
        type: "1",
        Items: [],
      },
    };
  },
  created() {
    let id = this.$route.params?.id;
    if (id) {
      this.$apis.mall.order
        .info({
          id: id,
          goods: true,
        })
        .then((res) => {
          if (res != null) {
            this.order = res;
          } else {
            this.$router.go(-1);
          }
        });
    }
  },
  methods: {
    //选择客户
    pickCustomer(res) {
      this.$set(this.order, "CustomerId", res.Id);
      this.$set(this.order, "CustomerName", res.Name);
      this.$set(this.order, "Linkman", res.Linkman);
      this.$set(this.order, "Linktel", res.Linktel);
      this.$set(this.order, "Address", res.Address);
    },
    //选择商品
    pickGoods() {
      if (!this.order.Type) {
        this.$message.error("请先选择订单类别后，才能选择商品");
        return;
      }
      this.$layer.iframe({
        title: "选择商品",
        area: ["800px", "640px"],
        content: {
          content: goodsPicker,
          parent: this,
          data: {
            customer: this.order.CustomerId,
            stock: this.order?.Type,
            callback: (res) => {
              res.forEach((item) => {
                if (
                  this.order.Items.findIndex((x) => x.GoodsId == item.Id) == -1
                ) {
                  this.order.Items.push({
                    GoodsId: item.Id,
                    Stock: item.Stock,
                    Name: item.Name,
                    Unit: item.Unit,
                    Price: item.Price,
                    Amount: 1,
                  });
                }
              });
            },
          },
        },
      });
    },
    //移除商品行
    onRemove(row) {
      this.order.Items.splice(row.$index, 1);
    },

    //提交订单
    onSubmit() {
      this.$refs["ff"].validate((valid) => {
        if (valid && !this.loading) {
          if (this.order.Items.length == 0) {
            this.$message.error("订单不能为空，请选择商品");
          }

          var items = {};
          this.order.Items.forEach((ele) => {
            items[ele.GoodsId] = ele.Amount;
          });

          this.loading = true;
          this.$apis.mall.order
            .submit({
              ...this.order,
              Items: items,
            })
            .then((res) => {
              this.$message({ message: "数据提交成功！", type: "success" });
              this.$router.replace({ path: `/mall/order/detail/${res.Id}` });
            })
            .catch((e) => {
              this.$message.error(e || "执行错误");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  min-width: 720px;
  display: flex;
  flex-direction: column;

  .form {
    padding: 30px;
    background-color: #fff;
    flex: 1;

    .el-form {
      min-width: 640px;
      width: 72%;
      margin: 0 auto;
    }
  }
}
</style>
